import { Link } from "react-router-dom";
import { Icon } from "./icons";
import "./legal.style.css";

const PolitiqueCookies = () => (
  <div className="legal-page">
    <Link to="/" className="legal-back">
      ← Retour à l’accueil
    </Link>
    <h1>Politique de cookies</h1>
    <p className="legal-lead">
      Cette page explique ce que sont les cookies, lesquels sont utilisés sur
      notre site et comment vous pouvez les gérer.
    </p>
    <p className="legal-updated">
      <Icon name="calendar" /> Dernière mise à jour · septembre 2026
    </p>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="cookie" />
      </div>
      <div className="legal-section-body">
        <h2>Qu’est-ce qu’un cookie&nbsp;?</h2>
        <p>
          Un cookie est un petit fichier texte déposé sur votre appareil
          (ordinateur, tablette, smartphone) lors de la visite d’un site web. Il
          permet notamment de faire fonctionner certaines fonctionnalités ou de
          mesurer l’audience.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="layers" />
      </div>
      <div className="legal-section-body">
        <h2>Cookies utilisés sur ce site</h2>
        <p>
          Notre site fait appel à des services tiers susceptibles de déposer des
          cookies :
        </p>
        <ul>
          <li>
            Google Tag Manager / Google Analytics — mesure d’audience et
            statistiques de visite (Google LLC)
          </li>
          <li>Google Maps — affichage de la carte de localisation (Google LLC)</li>
          <li>Google Fonts — affichage des polices d’écriture (Google LLC)</li>
          <li>
            Meta / Facebook — boutons de partage sur les réseaux sociaux (Meta
            Platforms, Inc.)
          </li>
          <li>
            Elfsight — affichage des avis clients Google dans la section
            « Avis » (Elfsight)
          </li>
        </ul>
        <p>
          Ces cookies sont déposés par des tiers ; leur durée de vie et leurs
          finalités précises sont décrites dans les politiques respectives de
          ces fournisseurs.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="settings" />
      </div>
      <div className="legal-section-body">
        <h2>Gérer les cookies</h2>
        <p>
          Vous pouvez à tout moment configurer votre navigateur pour refuser les
          cookies ou être averti de leur dépôt. Chaque navigateur propose ses
          propres réglages (menu « Options » ou « Préférences »). Le refus de
          certains cookies peut toutefois affecter le bon fonctionnement de
          certaines parties du site.
        </p>
      </div>
    </section>

    <section className="legal-section">
      <div className="legal-ico">
        <Icon name="info" />
      </div>
      <div className="legal-section-body">
        <h2>En savoir plus</h2>
        <p>
          Pour plus d’informations sur le traitement de vos données, consultez
          notre{" "}
          <Link to="/politique-confidentialite">
            Politique de confidentialité
          </Link>
          .
        </p>
      </div>
    </section>
  </div>
);

export default PolitiqueCookies;
